import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Badge } from './ui/badge';
import { Briefcase, Award } from 'lucide-react';
// Props: experience

const Experience = ({ experience }) => {
  if (!experience) return null;
  return (
    <section id="experience" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Experience</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Professional experience and industry exposure
          </p>
          <div className="w-20 h-1 bg-blue-900 mx-auto mt-6"></div>
        </div>

        <div className="space-y-8">
          {experience.map((exp) => (
            <Card key={exp.id} className="border-2 border-gray-100 hover:border-blue-200 transition-all hover:shadow-lg">
              <CardHeader>
                <div className="flex flex-col lg:flex-row gap-6">
                  {/* Company Logo Placeholder */}
                  <div className="flex-shrink-0">
                    <div className="w-20 h-20 bg-gradient-to-br from-blue-100 to-blue-200 rounded-lg flex items-center justify-center">
                      <Briefcase className="w-10 h-10 text-blue-900" />
                    </div>
                  </div>
                  
                  <div className="flex-1">
                    <div className="flex items-start justify-between">
                      <div>
                        <CardTitle className="text-2xl mb-2">{exp.role}</CardTitle>
                        <CardDescription className="text-lg">
                          <span className="font-semibold text-blue-900">{exp.company}</span>
                          <span className="text-gray-500"> • {exp.location}</span>
                        </CardDescription>
                        <p className="text-sm text-gray-500 mt-1">{exp.duration}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </CardHeader>
              
              <CardContent>
                <p className="text-gray-700 mb-6">{exp.description}</p>
                
                {/* Technologies */}
                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-3">Technologies Used</h4>
                  <div className="flex flex-wrap gap-2">
                    {exp.technologies.map((tech, index) => (
                      <Badge key={index} variant="secondary" className="bg-slate-100 text-gray-700">
                        {tech}
                      </Badge>
                    ))}
                  </div>
                </div>

                {/* Responsibilities */}
                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-3">Key Responsibilities</h4>
                  <ul className="space-y-2">
                    {exp.responsibilities.map((resp, index) => (
                      <li key={index} className="flex items-start gap-2 text-gray-700">
                        <span className="text-blue-900 mt-1">•</span>
                        <span>{resp}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Achievements */}
                {exp.achievements && exp.achievements.length > 0 && (
                  <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                    <div className="flex items-center gap-2 mb-3">
                      <Award className="w-5 h-5 text-amber-700" />
                      <h4 className="font-semibold text-amber-900">Key Achievements</h4>
                    </div>
                    <ul className="space-y-2">
                      {exp.achievements.map((achievement, index) => (
                        <li key={index} className="flex items-start gap-2 text-amber-900">
                          <span className="mt-1">✓</span>
                          <span>{achievement}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
